import {
  CarrierKind,
  ParamsRedirectToHold,
  RequestRedirectToHoldStatus,
  ResponseRedirectToHoldStatus,
  ResponseRedirectToHoldStatusV,
} from '../../../server/api/schema';

import { decode } from '../../../server/lib/codec';

export interface StatusParams {
  carrier: CarrierKind;
  trackingNumber: ParamsRedirectToHold['trackingNumber'];
  request: RequestRedirectToHoldStatus<null>;
}

const getStatus = async ({
  carrier,
  trackingNumber,
  request,
}: StatusParams): Promise<ResponseRedirectToHoldStatus> => {
  const url = `/api/v1/delivery-management/${carrier}/redirect-to-hold/${trackingNumber}/status`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const json = await response.json();

  return decode(ResponseRedirectToHoldStatusV, json);
};

export default getStatus;
